import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import NewCardIcon from '../../../../../assets/images/add_new_card_icon.svg';
import { ButtonDescription, ButtonTitle, Container, ImageWrapper, InlineDiv } from './InputCardDataButton.styles';

interface IProps {
  handleClick: () => void;
}

function InputCardDataButton(props: IProps): ReactElement {
  const { handleClick } = props;

  return (
    <Container onClick={handleClick} className="saved-instrument-input-card-data__container">
      <ImageWrapper className="image__wrapper">
        <img className="new_card__icon" src={NewCardIcon} alt="new card" />
      </ImageWrapper>
      <InlineDiv className="saved-instrument-input-card-data__details">
        <ButtonTitle className="saved-instrument-input-card-data__details-title">
          <FormattedMessage id="savedInstrument.cardData.input.title" />
        </ButtonTitle>
        <ButtonDescription className="saved-instrument-input-card-data__details-description">
          <FormattedMessage id="savedInstrument.cardData.input.description" />
        </ButtonDescription>
      </InlineDiv>
    </Container>
  );
}

export default InputCardDataButton;
